<template>
<div>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h2 class="card-title d-flex">{{$t('DOCUMENTS.QUEUE.HEADER.TITEL')}}
          <div class="ml-auto text-right">
            <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
          </div>
        </h2>
        <p class="card-subtitle">
          <span>{{$t('DOCUMENTS.QUEUE.HEADER.TEXT')}}</span>
        </p>
      </vs-card>
    </vs-col>
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
      <vs-card >
            <div id="doc_queue_table" class="vs-con-loading__container" >
              <vs-table
                search
                :data="documents"
                :noDataText="$t('DOCUMENTS.QUEUE.NO_DATA')"
                stripe
                max-items="25" 
                pagination
                hoverFlat>

                <template slot="header">
                  <h3>
                    {{$t('DOCUMENTS.QUEUE.TABLE.HEADER')}}
                  </h3>
                </template>
                <template slot="thead">                               
                  <vs-th sort-key="name">
                    {{$t('DOCUMENTS.QUEUE.TABLE.COL1')}}
                  </vs-th>
                  <vs-th sort-key="type">
                    {{$t('DOCUMENTS.QUEUE.TABLE.COL2')}}
                  </vs-th>
                  <vs-th sort-key="creator_name">
                    {{$t('DOCUMENTS.QUEUE.TABLE.COL3')}}
                  </vs-th>  
                  <vs-th sort-key="created">
                    {{$t('DOCUMENTS.QUEUE.TABLE.COL4')}}
                  </vs-th>  
                  <vs-th sort-key="status">
                    {{$t('DOCUMENTS.QUEUE.TABLE.COL5')}}
                  </vs-th>                                                                                                         
                  <vs-th></vs-th>                                                                                                                                             
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                    <vs-td :data="tr.name">
                      {{tr.name}}
                    </vs-td>                  
                    <vs-td :data="tr.type">
                      {{GetDokumentTypeText(tr.type)}}
                    </vs-td>     
                    <vs-td :data="tr.creator_name">
                      {{tr.creator_name}}
                    </vs-td> 
                    <vs-td :data="tr.created">
                      {{DateToString(tr.created,false)}}
                    </vs-td>   
                    <vs-td :data="tr.status">
                      {{GetDokumentStatusText(tr.status)}}
                    </vs-td>                                                                                                 
                    <vs-td>
                      <vs-button  @click="RestartPrint(tr)" class="ml-2" size="small" color="primary" type="filled" icon="replay"></vs-button>  
                      <vs-button  @click="OpenConfirmDeleteDoc(tr.id,tr.name)" class="ml-2" size="small" color="primary" type="filled" icon="delete"></vs-button>                        
                    </vs-td>                    
                                                                                                                                                                                              
                  </vs-tr>
                </template>
              </vs-table>
            </div>           
        </vs-card>
      </vs-col>
  </vs-row>

</div>
</template>

<script>

import helperMethods from '../helper/staticFuncHelper';
import enumHelper from '../helper/enumHelper';
import codeHelper from '../helper/staticCodeHelper';

export default {
  name: "DocumentQueue",
  components: {
  },
    data: function (){
      return {
      documents:[]
      };
  },
  mounted () {
      this.LoadData();
    },
  computed: 
  { 
    getTableData() {
      var data = [];
      if(this.$store.state.document.documentqueue.data != null)
      {
        data = this.$store.state.document.documentqueue.data
      }
      return data;
    },
    loadingTableData () {
      var loading = false;
      if(typeof(this.$store.state.document.documentqueue.status) != 'undefined')
        loading = this.$store.state.document.documentqueue.status.loading;
      return loading;
    }
  },
  watch: {
      getTableData(value) {
          this.documents = value;
      },
      loadingTableData(value)
      {
        if(value)
        {
          this.$store.dispatch('alertqueue/showLoader', {'id':'#doc_queue_table'});
        }
        else
        {
          this.$store.dispatch('alertqueue/hideLoader', {'id':'#doc_queue_table'});
        }
      },
    },
  methods: {    
      ...helperMethods,
      ...enumHelper,
      ...codeHelper,
      LoadData: function ()
      {
          this.$store.dispatch('document/getDocumentQueue'); 
      },
      RestartPrint(data){
        data.status = 1;
        this.$store.dispatch('document/updateDocumentQueueEntry',data); 
      },   
      OpenConfirmDeleteDoc(id,name) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.DELETE'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('DOCUMENTS.QUESTION.DELETE_QUEUE').replace("*1*",name),
          accept: this.SendDeleteRequest,
          parameters:{"id": id,"name": name}
        });
      
      },
      SendDeleteRequest: function(parameters)
      {
        this.$store.dispatch('document/deleteDocumentQueueEntry', parameters.id)
        .then(response => {
          if(response.success == true)
          {
            this.LoadData();
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('DOCUMENTS.SUCCESS.DELETE_QUEUE').replace("*1*",parameters.name)});  
          }
          else
          {
            var text = this.$t('DOCUMENTS.WARNING.DELETE_QUEUE').replace("*1*",parameters.name);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('DOCUMENTS.ERROR.DELETE_QUEUE').replace("*1*",error)});  
        });
      }
  }
};

</script>